// extracted by mini-css-extract-plugin
export default {"customImagesSize":"LadKP2duziX9qAp50ZmH"};